import { InteractionType } from "@/common/types";
import { InteractionOverlay } from "@/components/atoms/interactionOverlay";
import { PopoverView } from "@/components/atoms/popover";
import { useMemo } from "react";
import {
	InteractionPanelItemDescription,
	InteractionPanelItemType,
} from "../interaction/types";
import { InteractionHistoryListItemDto } from "./types";
import { useStyle } from "./style";
import { getHistoryInteractionIcon } from "@/common/helpers/interactionIconHelper";

export const HistoryInteractionIconOverlay: React.FC<{
	interactionHistoryItem: InteractionHistoryListItemDto;
}> = ({ interactionHistoryItem }) => {
	const classes = useStyle();

	const mapInteractionTypeAndStatusToPanelType = useMemo(() => {
		if (interactionHistoryItem.isCallback) {
			return InteractionPanelItemType.Callback;
		}

		const typeMapping = {
			[InteractionType.Call]: InteractionPanelItemType.Call,
			[InteractionType.Generic]: InteractionPanelItemType.Generic,
			[InteractionType.Voicemail]: InteractionPanelItemType.Voicemail,
			[InteractionType.Email]: InteractionPanelItemType.Email,
			[InteractionType.WhatsApp]: InteractionPanelItemType.WhatsApp,
			[InteractionType.Webchat]: InteractionPanelItemType.Webchat,
		};

		return typeMapping[interactionHistoryItem.type];
	}, [interactionHistoryItem]);

	const mapInteractionStatusToPanelDescription = useMemo(() => {
		if (interactionHistoryItem.isMissed) {
			return InteractionPanelItemDescription.Missed;
		}
		return interactionHistoryItem.isInboundInteraction
			? InteractionPanelItemDescription.Inbound
			: InteractionPanelItemDescription.Outbound;
	}, [interactionHistoryItem]);

	return (
		<PopoverView
			content={
				<InteractionOverlay
					item={{
						...interactionHistoryItem,
						type: mapInteractionTypeAndStatusToPanelType,
						statusOnPanel: mapInteractionStatusToPanelDescription,
						itemDebuggingId: interactionHistoryItem.debuggingId,
					}}
				/>
			}
			positioning={{
				position: "below",
			}}
			trigger={getHistoryInteractionIcon(interactionHistoryItem)}
			classes={{
				trigger: classes.interactionListIcon,
			}}
			openOnHover={true}
			mouseLeaveDelay={0}
		/>
	);
};
